import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

import { nearestTurnAtom } from '../../shared/nearest.turn';
import { useAtom } from 'jotai';
import {
  Button,
  Card,
  LinearProgress,
} from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import useConfirmTurnMessage from '../../Hooks/useConfirmTurnMessage';
import { retrunMsgData } from '../../functions/retrunMsgData';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import NearestTurnContent from './NearestTurnContent/NearestTurnContent';
import PayOptionBackdrop from '../PayOptionBackdrop/PayOptionBackdrop';
import { handleSaveNearestTurn } from '../../functions/HandleSaveNearestTurn';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';

const NearestTurn = ({ doctors }) => {
  const [openBackdrop, setBackdrop] = useState(false);

  const [backdropOpened, setBackdropOpened] = useState({
    isOpened: false,
  });

  const [nearestTurn] = useAtom(nearestTurnAtom);

  const nearestTurnMsg = FindLangKey(
    'get-new-turn-label-nearest-turn'
  );

  const label_price = FindLangKey(
    'genral-public-label-price-item'
  );

  const saveBtnMsg = FindLangKey('general-public-btn-save');

  const confirmMsg = useConfirmTurnMessage(
    retrunMsgData(nearestTurn)
  );

  const navigate = useContext(GlobalContext)?.navigate;

  const priceTag = Number(
    nearestTurn?.dayInfo?.hazineDaryafteNobat
  );

  useEffect(() => {
    if (backdropOpened.isOpened) {
      let swalTextElements =
        document.querySelector('.swal-text');
      swalTextElements.style.textAlign = 'center';
    }
  }, [backdropOpened, {}]);


  console.log('doctors--->',{doctors,nearestTurn})

  return (
    <React.Fragment>
      <FrameCard
        cardProps={{ p: '.3em', borderRadius: '20px' }}
        jsx={
          <div
            style={{
              backgroundColor: `${themeColors.ColorSecondary}`,
              p: '.3em',
              borderRadius: '20px',
            }}
          >
            {!nearestTurn ? (
              <LinearProgress sx={{ mt: '1em' }} />
            ) : (
              <div>
                <p>{nearestTurnMsg}</p>

                <NearestTurnContent
                  doctorList={nearestTurn}
                  label_price={label_price}
                />
              </div>
            )}
          </div>
        }
      />

      <Button
        sx={{
          mt: '1em',
          color: `${themeColors.ColorPrimary} !important`,
        }}
        variant="contained"
        fullWidth
        onClick={() => {
          setBackdropOpened({ isOpened: true });
          SwalAlert(
            'warning',
            confirmMsg,
            true,
            // // handleSaveNearestTurn
            // () => {
            //   SwalAlert('warning', 'Hello', true, () => {});
            // }
            () => {
              if (
                nearestTurn?.dayInfo
                  ?.daryafteNobateBaHazine &&
                nearestTurn?.dayInfo?.hazineDaryafteNobat
              ) {
                setBackdrop(true);
              } else {
                handleSaveNearestTurn(
                  nearestTurn,
                  navigate,
                  confirmMsg,
                  false,
                  nearestTurn,
                  null,
                  null,
                  `${
                    retrunMsgData(nearestTurn)?.serviceName
                  } دریافت نزدیک ترین نوبت برای`,
                  null,
                  true
                );
              }
            }
          );
        }}
      >
        {saveBtnMsg}
      </Button>
      <PayOptionBackdrop
        openBackdrop={openBackdrop}
        setBackdrop={setBackdrop}
        priceTag={priceTag}
        doctorList={doctors}
        navigate={navigate}
        confirmMsg={confirmMsg}
        nearestTurn={nearestTurn}
      />
    </React.Fragment>
  );
};

export default NearestTurn;
